import {useEffect, useState} from "react";
import {timeInSeconds} from "../helpers/timeInSeconds";
import {useDispatch} from "react-redux";
import {logOut} from "../redux/slices/authSlice";
import {getStoredSessionTimeout} from "../helpers/getStoredSessionTimeout";
import {END_SESSION_TIMEOUT_IN_SECONDS, WARNING_TIME_IN_SECONDS} from "../config/constants";

export const useIsOneHourPassed = () => {
    const [openSessionDialog, setOpenSessionDialog] = useState(false);
    const [counterMsg, setCounterMsg] = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
        const intervalId = setInterval(() => {
            const passedSeconds = timeInSeconds() - getStoredSessionTimeout();
            const remainingSeconds = END_SESSION_TIMEOUT_IN_SECONDS - passedSeconds;


            // Checking for handling Logout after  passing the waiting time
            if (remainingSeconds <= 0)
                handleLogout()

            // Checking for updating the countdown timer of the dialog message
            if (remainingSeconds <= 60)
                setCounterMsg(remainingSeconds)

            // Checking for appearing the warning dialog
            if (passedSeconds >= WARNING_TIME_IN_SECONDS && !openSessionDialog)
                setOpenSessionDialog(true);
        }, 1000)
        return () => clearInterval(intervalId)
    }, [])

    useEffect(() => {
        // stay active in all multi tabs open
        const handleStorage = (event) => {
            if (event.key === "logoutFromAllTabs") {
                localStorage.removeItem("sessionTimeout");
                localStorage.removeItem("logoutFromAllTabs"); // trigger event for multi tabs open
                localStorage.removeItem("reload-tabs");
                dispatch(logOut());
            }else if(event.key === 'reload-tabs') {
                window.location.reload();
            }
        };

        window.addEventListener("storage", handleStorage);
    }, []);

    const handleStayActive = () => {
        localStorage.setItem("sessionTimeout", timeInSeconds());
    }

    const handleLogout = () => {
        localStorage.setItem("logoutFromAllTabs", timeInSeconds()); // trigger event for multi tabs open
        dispatch(logOut());
    }

    return {openSessionDialog, setOpenSessionDialog, counterMsg, handleStayActive, handleLogout}
}